import { useContext } from "react";
import { DropdownContext } from "../../context/dropdown.context";

import ArrowDown from '../../assets/arrow-down.png'
import ArrowUp from '../../assets/arrow-up.png'

import { ArrowIconContainer, ArrowIcon } from './header-arrow-icon.styles.jsx';

const HeaderArrowIcon = () => {
  const { isDropdownOpen, setIsDropdownOpen } = useContext(DropdownContext);
  const toggleIsDropdownOpen = () => setIsDropdownOpen(!isDropdownOpen);

  var arrowDirection = ArrowDown;
  if (isDropdownOpen) {
    arrowDirection = ArrowUp;
  } else {
    arrowDirection = ArrowDown;
  }

  return (
    <ArrowIconContainer onClick={toggleIsDropdownOpen}>
      <a href="#top"><ArrowIcon src={arrowDirection} alt="arrow-down" /></a>
    </ArrowIconContainer>
  )
}

export default HeaderArrowIcon;